// extracted by mini-css-extract-plugin
export var avatarContainer = "_5t-1";
export var largeAvatarContainer = "_5t-2";
export var smallAvatarContainer = "_5t-0";